module.exports = __webpack_public_path__ + "img/avatar.7159e4b.png";